<template>
  <div class="analyses-thermostats-search-index">
    <Filters
      :filters="analysesThermostatsSearchFilters"
      filter-key="analysesThermostatsSearch"
      :initial-data="filtersStatus.analysesThermostatsSearch"
      :loading="filtersLoading"
    />

    <TableWrapper
      :table-columns="analysesThermostatsSearchColumns"
      table-key="analysesThermostatsSearch"
      row-key="tableId"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import {
    analysesThermostatsSearchColumns,
    analysesThermostatsSearchFilters,
  } from '@/config';
  import { thermostatsApi } from '@/api';
  import tableHelper from '@/services/tableHelper';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';

  export default {
    name: 'AnalysesThermostatsSearchIndex',
    components: {
      Filters,
      TableWrapper,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        analysesThermostatsSearchColumns,
        analysesThermostatsSearchFilters,
      };
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const where = tableHelper.whereFilters(
            this.filtersStatus.analysesThermostatsSearch,
            this.analysesThermostatsSearchFilters
          );
          const analysesThermostatsSearchIndex =
            await thermostatsApi.getTemperatureTrailSearch(
              this.tableFilters('analysesThermostatsSearch'),
              where,
              { signal }
            );
          const analysesThermostatsSearchCount =
            await thermostatsApi.getTemperatureTrailSearchCount(where, {
              signal,
            });
          this.updateTableRows({
            tableKey: 'analysesThermostatsSearch',
            rows: analysesThermostatsSearchIndex.data,
          });
          this.updateTableCount({
            tableKey: 'analysesThermostatsSearch',
            count: analysesThermostatsSearchCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
    },
  };
</script>
